module.exports = __webpack_public_path__ + "media/Sea4006.2dbf1d01.mp4";